import { render, staticRenderFns } from "./NotificationBody.vue?vue&type=template&id=d93858a4&scoped=true&"
import script from "./NotificationBody.vue?vue&type=script&lang=js&"
export * from "./NotificationBody.vue?vue&type=script&lang=js&"
import style0 from "./NotificationBody.vue?vue&type=style&index=0&id=d93858a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d93858a4",
  null
  
)

export default component.exports